import { Box, CircularProgress } from '@mui/material'
import { Navigate, Route, Routes } from 'react-router-dom'

import { useAuth } from './auth/useAuth'
import AppShell from './components/AppShell'
import AuditPage from './pages/AuditPage'
import ChangePasswordPage from './pages/ChangePasswordPage'
import LoginPage from './pages/LoginPage'
import MyAccountPage from './pages/MyAccountPage'
import OrderPage from './pages/OrderPage'
import QueuePage from './pages/QueuePage'
import { JobsProvider } from './queue/JobsProvider'
import UsersPage from './pages/UsersPage'

export default function App() {
  const { user, loading } = useAuth()

  if (loading) {
    // Never flash the sign-in form at somebody who is already signed in.
    return (
      <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
        <CircularProgress />
      </Box>
    )
  }

  // Signed out means exactly one thing on screen. No chrome, no navigation,
  // nothing to look at until we know who you are -- and because every 401 in
  // the app routes back to here, an expired session lands on the same prompt
  // rather than scattering errors through whatever screen was open.
  if (!user) {
    return <LoginPage />
  }

  // A password someone else chose is a handover credential. Nothing else is
  // reachable until it is replaced.
  if (user.must_change_password) {
    return <ChangePasswordPage />
  }

  const isSysadmin = user.role === 'sysadmin'

  return (
    <JobsProvider>
      <AppShell>
        <Routes>
          <Route path="/order" element={<OrderPage />} />
          <Route path="/queue" element={<QueuePage />} />
          <Route path="/account" element={<MyAccountPage />} />
          <Route
            path="/users"
            element={isSysadmin ? <UsersPage /> : <Navigate to="/order" replace />}
          />
          <Route
            path="/audit"
            element={isSysadmin ? <AuditPage /> : <Navigate to="/order" replace />}
          />
          <Route path="*" element={<Navigate to="/order" replace />} />
        </Routes>
      </AppShell>
    </JobsProvider>
  )
}
